module.exports = __webpack_public_path__ + "images/patterns/dark/StripeVertical.0e628d414c23eaa2c0e1.svg";